import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Flex,
  Image,
  Box,
  ButtonGroup,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Notification from "../../services/Notification";

export default function ImageUploadModal({
  isOpen,
  onClose,
  setImageValue,
}: any) {
  const initialRef = React.useRef(null);
  const email = localStorage.getItem("logged_in_email");

  // const toast = useToast();

  const [tab, setTab] = useState("choose");

  const [imageUrls, setImageUrls] = useState<any>([]);

  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [imageUploaded, setImageUploaded] = useState(false);

  const [file, setFile] = useState<any>(null);
  const [filename, setFilename] = useState("");

  const getUploadedImageUrl = async () => {
    const fileName = filename.trim();

    await Notification.uploadedImageUrl(email, fileName, file).then((res) => {
      setImageUploaded(true);
      setSelectedImageUrl(res?.data?.image?.file_url);
    }).catch((e)=>{
      console.error(e)
    });
  };

  const getImageUrls = async () => {
    await Notification.getImageUrls().then((res) => {
      setImageUrls(res?.data?.images.map((img: any) => img?.file_url));
    });
  };


  useEffect(() => {
    getImageUrls();
  }, [tab]);

  return (
    <>
      <Modal
        size="xl"
        initialFocusRef={initialRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.3)" />
        <ModalContent>
          <ModalHeader>Select Image</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <ButtonGroup gap={4} pb={5}>
              <Button
                onClick={() => {
                  setTab("choose");
                  setSelectedImageUrl("");
                  setFilename("");
                }}
                borderBottom={
                  tab === "choose"
                    ? "2px solid #327171"
                    : "2px solid transparent"
                }
                _hover={{ borderBottom: "2px solid yellow" }}
                borderRadius={0}
              >
                Choose Image
              </Button>
              <Button
                onClick={() => {
                  setTab("upload");
                  setSelectedImageUrl("");
                  setFilename("");
                }}
                borderBottom={
                  tab === "upload"
                    ? "3px solid #327171"
                    : "2px solid transparent"
                }
                _hover={{ borderBottom: "2px solid yellow" }}
                borderRadius={0}
              >
                Upload Image
              </Button>
            </ButtonGroup>

            <Box
              position="relative"
              height="400px"
              // maxH="400px"
              overflowY="auto"
              // p={4}
            >
              {tab === "choose" && (
                <Box
                  position="absolute"
                  top={0}
                  left={0}
                  right={0}
                  bottom={0}
                  overflowY="auto"
                  p={4}
                >
                  <Flex wrap="wrap" gap={6} justify="center">
                    {imageUrls.map((url: any, index: any) => (
                      <Image
                        key={index}
                        src={url}
                        alt={`Image ${index + 1}`}
                        boxSize="100px"
                        objectFit="cover"
                        borderRadius="md"
                        border={
                          selectedImageUrl === url ? "2px solid blue" : "none"
                        }
                        cursor="pointer"
                        onClick={() => setSelectedImageUrl(url)}
                      />
                    ))}
                  </Flex>
                </Box>
              )}
              {tab === "upload" && (
                <VStack
                  position="absolute"
                  top={0}
                  left={0}
                  right={0}
                  bottom={0}
                  mt={10}
                  px={4}
                  spacing={6}
                  overflowY="auto"
                >
                  {selectedImageUrl && (
                    <Image
                      src={selectedImageUrl}
                      alt="Uploaded Image"
                      boxSize="100px"
                      objectFit="cover"
                      borderRadius="md"
                      border="2px solid blue"
                    />
                  )}

                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setFile(e.target.files?.[0])}
                    border="none"
                    p={2}
                  />

                  <Input
                    placeholder="Enter filename"
                    value={filename}
                    onChange={(e) => setFilename(e.target.value)}
                  />

                  <Button
                    colorScheme="yellow"
                    onClick={() => getUploadedImageUrl()}
                    disabled={imageUploaded}
                  >
                    Upload
                  </Button>
                </VStack>
              )}
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={() => {
                setImageValue(selectedImageUrl);
                setImageUploaded(false);
                onClose();
              }}
              isDisabled={!selectedImageUrl}
            >
              Submit
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
